module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAQCAYAAADESFVDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAKNJREFUeNpiYKAGOHPmzHwWPJICQGo+EAuw4FGwH4gNgNiRiYCCCSYmJgeY8Ci4AMSNIHEmJAUGSAo+AHEi0BQQzcAIVRAAcyRUgSNQwQWYAYxQBeuRbDVEVgCz7gAUw0A+umcYkQMNSCVAuQuApiUimwQGUMFCKDcBqKkfwyQkExOgnmCA+nABI44QhwUH2CNM2BRBfecI5fYzEkgBYBMBAgwAZwQ/CwObphMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/exercise-3/cinetics-line/prev.png
// module id = 265
// module chunks = 0